import Vue from 'vue'
import Vuex from 'vuex'
import { entries, merge } from 'lodash'

export function app(name, component, customStore = {}) {

	Vue.use(Vuex)

	const node = document.querySelector(`#vue-app[vue-app=${name}]`)

  	// Basic Root store
  	const defaultStore = {
    	state: {},
    	getters: {},
    	plugins: [],
  	}

  	const store = merge({}, defaultStore, customStore)

	// Read and pass props into the main coponent
	const props = {}
	entries(node.dataset).forEach(([key, value]) => {
		try {
			props[key] = JSON.parse(value)
		} catch (e) {
			props[key] = value
		}
	})

	// Basic Root instance
	const instance = {
		name: 'App',
		store: new Vuex.Store(store),
		render(h) {
			return h(
				'div',
				{
					attrs: {
						id: `app-${name}`,
					},
				},
				[h(component, { props })]
			)
		},
	}

	return new Vue(instance).$mount(node)
}



// WEBPACK FOOTER //
// ./assets/vue/library/vue-app.js